import ReactDOM from "react-dom";
import moment from "moment";
import { courtTypesByState } from "../../utils/courtTypes";
import { acdCodes } from "../../utils/acdCodes";
import { useRef, useState } from "react";
//import { useNavigate } from "react-roouter-dom";
import PostConviction from "./postConviction";
import { canadianProvinces } from "../../utils/countryOptions";
import { countryOptions } from "../../utils/countryOptions";
import { suffix } from "../../utils/withdrawalOptions";
import { useNavigate, useParams } from "react-router-dom";
import {defaultDriverData, makeWithdrawalObjectForAdd, errMessage,
    postJson, toYMD, foreignData,  buildSource,
    isCDLHolder} from "../../utils/data";
import { formatDOB, validateDate } from "../../components/consts/dateMask"
import { useAuth } from "../../context/AuthContext";
import StateSel from "./selectQueries/stateSel";
import { mexicanStates } from "../../utils/countryOptions";
import { usStates } from "../../utils/usStates";
import { useEffect } from "react";
import { stagingState } from "../../utils/withdrawalOptions";
import { fcwdOnly } from "../../utils/data";

//import UpdateDriver from "./updatedriver"; 

export default function NoDriverConviction(){

    const {source, token, userState, email, roles} = useAuth();
    const { jurisdiction, license } = useParams();
    const navigate = useNavigate();
    const [courtType, setCourtType] = useState("");
    const [acdCode, setAcdCode] = useState("");
    const [selectedAcd, setSelectedAcd] = useState(null);
    const [acdDetail, setAcdDetail] = useState("");
    const [cmvCode, setCmvCode] = useState("");
    const [hazMat, setHazMat] = useState("");
    const [maxVal, setMaxVal] = useState(0);
    const [err, setErr] = useState();
    const [stateStyle, setStateStyle] = useState(null);
    const [state, setState] = useState(defaultDriverData.state);
    const [country, setCountry] = useState('');


    //const [msg, setMsg] = useState("Driver is not a CDL Holder. If CMV = Yes, add to FCWD. If CMV = No, do not add to FCWD.")
    const [validated, setValidated] = useState(false);

    const saver = useRef(null);
    const warnRef = useRef(null);
    const acdDetailsRef = useRef(null);
    const userCourtType = "DEFAULT";
    let isCanada = false;

    const defined = (v) => v !== undefined && v !== null && v !== "";

       let cdl = "9";
    
        if(isCDLHolder === true){
            cdl = "1";
        } 
    
        if(isCDLHolder === false){
            cdl = "2"
        }

        const handleCountryOptions = (e) => {
                const {value} = e.target;
                setCountry(value);
                switch (value){
                    case 'CA':
                        setStateStyle(canadianProvinces);
                        break;
                    case 'MX':
                        setStateStyle(mexicanStates);
                        break;
                    case 'US':
                        setStateStyle(stagingState);
                        break;
                    default:
                        setStateStyle(null);
                        break
                }
        }

//alert(JSON.stringify(defaultDriverData))

//alert(defaultDriverData.dob)

    let useStat = ""
    let useLic = ""

    if((!defined(defaultDriverData.driverLicense)) || !defined(defaultDriverData.surName)){
        useLic = license;
    } else {
        useLic = defaultDriverData.driverLicense;
    }

    if(!defined(defaultDriverData.driverState)){
        useStat = jurisdiction;
    } else {
        useStat = defaultDriverData.driverState;
    }

let ny = "";
if(defaultDriverData.dob === ""){
  let dp = new Date().toISOString().split('T')[0];
  const [y,m,d] = dp.split('-');
  const yn = y - 21;
  ny = yn+'-'+m+'-'+d; 
} else {
    ny = defaultDriverData.dob;
}

    const defaults = {
        "courtType"     : "",
        "addCode"       : "",
        "selectedAcd"   : "",
        "cmvCode"       : "",
        "hazMat"        : "",
        "maxval"        : "",
        "userCourtType" : "",
        "convictionDate" : "",
        "citationDate"   : "",
        "convOff"        : "",
        "stateNative"    : "",
        "comments"       : "Conviction Added",
        "acdDetail"      : "",
        "ssn"            : "",
        "street1"        : "",
        "street2"        : "",
        "suffix"         : "",
        "county"         : "",
        "country"        : defaultDriverData.country,
        "state"          : defaultDriverData.driverState,
        "userState"      : userState,
        "firstName"      : defaultDriverData.firstName,
        "surName"        : defaultDriverData.surName,
        "dob"            : ny
    }
    
    //const navigate = useNavigate();
    const [formData, setFormData] = useState(defaults);    
    const acdDet = ['A11', 'A91', 'D45', 'D53', 'D56', 'S92'];
    const acdOther = ['A04','A94','U07','U08','U09','U10','B91','M85','M86'];
    const acdMajor = ['A04', 'A94', 'U07', 'U08', 'U09', 'U10'];
    const acdSerious = ['B91', 'M85', 'M86'];

    canadianProvinces.forEach((v) => {
        if(jurisdiction === v.code){
            isCanada = true;
        }
    })

    const disableKey  = (event) =>{ 
        event.preventDefault();
        const { name, value } = event.target;
        if(formatDOB(value)){
            return;
        }
        setFormData((formData) => ({ ...formData, [name]: 0 }));
  }
    
    
    const convertDate = (d) =>{
        if (!defined(d)) return undefined;
        // If already "YYYYMMDD", return as-is:
        if (typeof d === "string" && /^\d{8}$/.test(d)) return d;
        try {
            const dt = new Date(d);
            const y = dt.getFullYear();
            const m = String(dt.getMonth() + 1).padStart(2, "0");
            const day = String(dt.getDate()).padStart(2, "0");
            return `${y}${m}${day}`;
        } catch {
            return undefined;
        }
};

    const cleanDate = (d) => {
        if(d === undefined){
            return;
        }
        if(d.includes("-")){
            return d.replace(/-/g, ""); 
        } else {
            return d;
        }
    }


    const setDefaultName = (name, value) => {
        console.log("Received", name, value);
        // switch(e.target.name){
    }
    
    const handleChange = (event) =>{
        //event.preventDefault();

        if(hazMat === "1"){
            setCmvCode("1");
        }
        const { name, value } = event.target;
        setFormData((formData) => ({ ...formData, [name]: value }));
           // alert(formData.dob)
    }
    
    const  handleCancel = (e) => {
        e.preventDefault();
        navigate(-1);
    }

    const checkACD = (e) => {
        if(acdDetail !== ""){
            setAcdDetail("");
            return;
        }
    }
    
   const handleAcdChange = (e) => {
        const code = e.target.value;
        setAcdCode(code);
        if (acdDetailsRef.current) {
            acdDetailsRef.current.value = "";
        }
        acdDet.includes(code)//"S92"
            ? setMaxVal(5)
            : code.startsWith("D")
                ? setMaxVal(3)
                : setMaxVal(2);
        const found = acdCodes.find((a) => a.code === code);
        setSelectedAcd(found || null);
    };

    const handleSubmit =  async(e) => {
        e.preventDefault();
        let errs = [];
        setErr("");
        const form = e.target;

        if (form.checkValidity() === false) {
            e.stopPropagation(); // prevent submit if invalid
        }

        
        validateDate(formData.citationDate, false, errs);
        validateDate(formData.convictionDate, false, errs);
        
        if(!isCDLHolder && (cmvCode !== "1")){
            errs.push("NON CDLIS CONVICTION")
        }

        if(acdDetail.includes(".")){
            if(selectedAcd.code === "A11"){
                if(selectedAcd.code === "A91"){
                    errs.push(selectedAcd.code+" ACD CONV CODE VALUE REQUIRES BLANK CONV OFF DET FOR ACD CONV CODE:")
                }
            }
        }

        if(cmvCode === 1){
            setHazMat(1)
        }


        if(formData.code === acdDet.includes(formData.code)) {
            acdDetail = formData.acdDetail;
            if(formData.acdDetail === ""){
                return(
                    <>ACD Code {formData.code} Requires Input</>
                )
            }            
        }
        
        let dobMatch = "yes";
        let nameMatch = "yes";
        let isDown = "no";

        if(cleanDate(foreignData.dob) !== cleanDate(formData.dob)) {
            console.log("DOB different")
            dobMatch="no"
        }

        if((foreignData.surName && formData.surName !== foreignData.surName) ||
            (foreignData.suffix && formData.suffix !== foreignData.suffix) ||
            (foreignData.middleName && formData.middleName !== foreignData.middleName) ||
            (foreignData.firstName && formData.firstName !== foreignData.firstName)
        ){
            console.log("Name different")
            nameMatch="no"
        }

        setValidated(true)

        if(selectedAcd === null){
            return;
        }

        if(errs.length > 0){
            setErr(errs)
            return;
        }

        if (form.checkValidity() === false) {
            e.stopPropagation(); // prevent submit if invalid
            return;
        } 
        
        let entry = {};
           if(defined(roles)){
                if(roles.includes("fcwdHelpDesk")){
        entry = {
                "Header": {
                    "Metadata": {
                        "UserID": email
                    }
                },
                "Body": {//this request adds a new conviction(if not duplicate) and review records(One for CAorMXdown, one for Name mismatch and another for DOB mismatch, And, one for Conviction is Major, Serious, RRHGC, VOOSO...due to B27 ACD code).
                    "Source":{
                        "DataSource": source,
                        "CAorMXDown": isDown, //(Yes or No); Choose Yes when Status response has "Canada is Currently Unavailable" or "Mexico eLicencia is currently unavailable"  
                        "NameMatched":nameMatch, //(Yes or No) if No, need to send SourceNameObj(foreign data received from MX or Canada) and ReqNameObj(Jurisdiction data from request) name objects in UnMatchedData else don't send name fields in UnMatchedData object. The value is Yes when matched or if record is not found.
                        "DOBMatched": dobMatch //(Yes or No) if No, need to send SourceDob(foreign data) and ReqDob(Jurisdiction data from request) values in UnMatchedData else don't send DOB fields in UnMatchedData object. The value is Yes when matched or if record is not found.
                    },
                    "PersonDetails": {
                        "PersonName": {
                            "SurName": formData.surName,
                            "FirstName": formData?.firstName,
                            "MiddleName": formData.middleName,
                            "Suffix": formData?.suffix
                        },
                        "PhysicalDetails": {
                            "Sex": formData?.sex,
                        },
                        "DOB":  cleanDate(formData.dob) , //cleanDate(formData?.dob),
                        "SSN": formData?.ssn,
                        "MailingAddress": {
                            "Line1": formData?.street1,
                            "Line2": formData?.street2,
                            "City": formData?.city,
                            "State": state,
                            "Zip": formData?.zip,
                            "County": formData?.county,
                            "Country": country
                        }
                    },
                    "License": {
                        "JurisdictionOfIssue": useStat,
                        "LicenseNumber": useLic
                    },
                    "Convictions": {
                        "JurisdictionCodeConvicting": formData?.userState,
                        "CitationDate": cleanDate(formData.citationDate),
                        "ConvictionDate": cleanDate(formData.convictionDate),
                        "ConvictionCourtType": courtType,
                        "ConvictionCommercialVehInd": cmvCode,
                        "ConvictionHazmatInd": hazMat,
                        "CDLIndicator": (isCanada && cmvCode === "1") ? cmvCode : cdl,
                        "ConvictionJurisCourtReportId": formData.convOff,
                        "ConvictionJurisdictionOffenseCode": formData.stateNative,
                        "ConvictionOffenseAcdCode": selectedAcd.code,
                        "ConvictionOffenseDetailAcd": acdDetail,
                        "ConvictionStatusNotes": formData.comments,
                        "ConvictionUserId": email //sessionStorage.getItem('email')
                    },
                    "UnMatchedData":{  //if NameMatched and DOBMatched values are Yes, then send an empty object as UnMatchedData : {}
                        "SourceNameObj": { //if NameMatched is Yes, these Name fields are not reviewed for changes
                            "SurName": foreignData?.surName,
                            "FirstName": foreignData?.firstName,
                            "MiddleName": foreignData?.middleName,
                            "Suffix": foreignData?.suffix
                        },
                        "ReqNameObj": {
                            "SurName": formData?.surName,
                            "FirstName": formData?.firstName,
                            "MiddleName": formData?.middleName,
                            "Suffix": formData?.suffix
                        },
                        "DOBObject": {  //if DOBMatched is Yes, these DOB fields are not reviewed for changes
                            "SourceDob": foreignData.dob,
                            "ReqDob": formData.dob
                        }
                    }
                }
            }
         }   else {
   
            entry = {
                "Header": {
                    "Metadata": {
                        "UserID": email,
                    }
                },
                "Body": {
                    "Source":{
                        "DataSource": source,
                        "CAorMXDown": isDown
                    },
                    "PersonDetails": {
                        "PersonName": {
                            "SurName": formData?.surName,
                            "FirstName": formData?.firstName,
                            "MiddleName": formData?.middleName,
                            "Suffix": formData?.suffix
                        },
                        "PhysicalDetails": {
                            "Sex": formData?.sex
                        },
                        "DOB": cleanDate(formData?.dob),
                        "SSN": formData?.ssn,
                        "MailingAddress": {
                            "Line1": formData?.street1,
                            "Line2": formData?.street2,
                            "City": formData?.city,
                            "State": state,
                            "Zip": formData?.zip,
                            "County": formData?.county,
                            "Country": country
                        }
                    },
                    "License": {
                        "JurisdictionOfIssue": useStat,
                        "LicenseNumber": useLic
                    },
                    "Convictions": {
                        "JurisdictionCodeConvicting": formData?.userState,
                        "CitationDate": cleanDate(formData.citationDate),
                        "ConvictionDate": cleanDate(formData.convictionDate),
                        "ConvictionCourtType": courtType,
                        "ConvictionCommercialVehInd": cmvCode,
                        "CDLIndicator": (isCanada && cmvCode === "1") ? cmvCode : cdl,
                        "ConvictionHazmatInd": hazMat,
                        "ConvictionJurisCourtReportId": formData.convOff,
                        "ConvictionJurisdictionOffenseCode": formData.stateNative,
                        "ConvictionOffenseAcdCode": selectedAcd.code,
                        "ConvictionOffenseDetailAcd": acdDetail,
                        "ConvictionStatusNotes": formData.comments,
                        "ConvictionUserId": email
                    }
                }
            

            }
        }
    }


    console.log(JSON.stringify(entry))


        try {    
            ReactDOM.render(<PostConviction data={entry} fcwdOnly={fcwdOnly} auth={token}/>,
                saver.current); 
        } catch(err){
            alert(err)
        }
        
    };
    
    return (
        <>
        <div className="App">
        <div ref={saver}></div>
        <div>{errMessage}</div>
        <h1>Add Conviction</h1>
        <div style={{color: "red"}}>{err}</div>
            <div id="table">
                <div className="row">
                    <div className="col-md-5">
                        <label className="form-label"><b>Driver State</b></label>
                        <input className="form-control" type="text"
                            value={useStat} disabled />
                    </div>
                    <div className="col-md-5">
                        <label className="form-label"><b>Driver License</b></label>
                        <input className="form-control" type="text"
                            value={useLic} disabled />
                    </div>
                </div>
                    <form
                        className={`needs-validation ${validated ? "was-validated" : ""}`}
                        id="Index-form"
                        noValidate
                        onSubmit={handleSubmit}
                    > 
                    <div className="row">
                        <div className="col-md-3">
                            <label className="form-label">
                                <b>First Name</b>
                            </label>
                            <input type="text"
                                className="form-control"
                                name="firstName"
                                onChange={(e) => handleChange(e)}
                                value={formData.firstName}>
                            </input>
                        </div>
                        <div className="col-md-3">
                            <label className="form-label">
                                <b>Middle Name</b>
                            </label>
                            <input type="text"
                                className="form-control"
                                name="middleName"
                                size="20"
                                onChange={(e) => handleChange(e)}
                                value={formData.middleName}>
                            </input>
                        </div>
                        <div className="col-md-3">
                            <label className="form-label">
                                <b><span className="text-danger">*</span>Last Name</b>
                            </label>
                            <input type="text"
                                required
                                className="form-control"
                                name="surName"
                                size="20"
                                onChange={(e) => handleChange(e)}
                                value={formData.surName}>
                            </input>
                            <div className="invalid-feedback">Please enter a last name</div>
                        </div>
                        <div className="col-md-3">
                            <label className="form-label"><b>Suffix</b></label>
                                <select className="form-select"
                                    value={formData.suffix}
                                    name="suffix"
                                    onChange={(e) => handleChange(e)}
                                >
                                <option defaultValue=""> -- Suffix -- </option>
                                    {suffix.map((val) => (
                                        <option value={val}>{val}</option>
                                        ))}
                                </select>
                            </div>
                            <div className="row">
                            <div className="col-md-2">
                                <label className="form-label">
                                    <b><span className="text-danger">*</span>Date of Birth</b>
                                </label>
                                <input type="date" className="form-control" 
                                    placeholder="MM/DD/YYYY"
                                    data-index="1"  name='dob'  
                                    value={moment(formData.dob).format("YYYY-MM-DD")}
                                    onChange={(e) => handleChange(e)}
                                    max={moment().format("YYYY-MM-DD")}
                                    onKeyDown={(e) => disableKey(e)}
                                    pattern='(0[1-9]|1[1,2])(\/|-)(0[1-9]|[12][0-9]|3[01])(\/|-)(19|20)\d{2}' 
                                required />
                             <div className="invalid-feedback">Please enter a valid DOB</div>
                            </div> 
                        </div>
                            <div><br /></div>  
                        <hr />
                        Residence
                        <br />
                        </div>
                        <div className="row">
                            <div className="col-md-2">
                                <label className="form-label">
                                    <b>Street address 1</b>
                                </label>
                                <input type="text"
                                    className="form-control"
                                    name="street1"
                                    size="20"
                                    onChange={(e) => handleChange(e)}
                                    value={formData.street1}>
                                </input>
                            </div>
                            <div className="col-md-2">
                                    <label className="form-label">
                                        <b>Street Address 2</b>
                                    </label>
                                    <input type="text"
                                        className="form-control"
                                        name="street2"
                                        size="20"
                                        onChange={(e) => handleChange(e)}
                                        value={formData.street2}>
                                    </input>
                            </div>
                            <div className="col-md-2">
                                <label className="form-label">
                                    <b>City</b>
                                </label>
                                <input type="text"
                                    className="form-control"
                                    name="city"
                                    size="20"
                                    onChange={(e) => handleChange(e)}
                                    value={formData.city}>
                                </input>
                            </div>
                            
                            <div className="col-md-2">
                                <label className="form-label">
                                    <b>County</b>
                                </label>
                                <input type="text"
                                    className="form-control"
                                    name="county"
                                    size="20"
                                    onChange={(e) => handleChange(e)}
                                    value={formData.county}>
                                </input>

                            </div>
                         <div className="col-md-3">
                                  {country !== 'CA' ? 
                                  <label className="form-label"><b>State</b></label>
                                  :
                                  <label className="form-label"><b>Providence</b></label>}
                                  {stateStyle === null ?
                                  (<input autoComplete="off" className="form-control" type="text"
                                  onChange={(e) => setState(e.target.value)}
                                  value={state} />)
                                  :
                                  <select className="form-control form-select" aria-label=".form-select-lg example"
                                    value={state}
                                    onChange={(e) => setState(e.target.value)}>
                                        <option value= "" disabled> -- select an option -- </option>
                                        {stateStyle.map((opt) => (
                                            <option key={opt.code} value={opt.code}>
                                            {opt.label}
                                            </option>
                                        ))}
                                    </select>
                                }
                              </div>
                            <div className="row">
                           <div className="col-md-3">
                                <label className="form-label"><b>Country</b></label>
                                <select className="form-select" aria-label=".form-select-lg example"   
                                    value={country}
                                    onChange={handleCountryOptions}
                                >
                                    <option value=""> -- Country -- </option>
                                    <option value="US">(US) US - United States</option>
                                    {Object.values(countryOptions).flat().map((opt) => (
                                        <option key={opt.code} value={opt.code}>
                                        {opt.label}
                                        </option>
                                    ))}
                                </select>
                                <div className="invalid-feedback">Please enter the Country</div>
                            </div>
                            <div className="col-md-1">
                                <label className="form-label">
                                    <b>Zip Code</b>
                                </label>
                                <input type="text"
                                    className="form-control"
                                    name="zip"
                                    size="20"
                                    onChange={(e) => handleChange(e)}
                                    value={formData.zip}>
                                </input>
                            </div>
                            </div>
                            <div>
                            <br />
                        </div>
                    <hr />
                        Conviction
                    </div>
                <div className="row">
                    <div className="col-md-3">
                        <label className="form-label">
                            <b><span className="text-danger">*</span>Citation Date</b>
                        </label>
                        {hazMat === "h9" || cmvCode === "c9" ? (
                            <><input
                                        type="date"
                                        className="form-control"
                                        name="citationDate"
                                        onKeyDown={(e) => disableKey(e)}
                                        max={moment("2007-12-31").format("YYYYMMDD")}
                                required />
                                
                                {hazMat === "h9" ? (
                                    <div className="invalid-feedback">CONV HAZ IND MUST = 1 OR 2, FOR CITATION DATE &gt; 200701231</div>
                                        ) : (
                                        <div className="invalid-feedback">CONV CMV IND MUST = 1 OR 2, FOR CITATION DATE &gt; 200701231</div>
                                            )}
                                        </>
                                        ) : (
                            
                                <><input type="date" className="form-control" 
                                    placeholder="MM/DD/YYYY"
                                    name="citationDate"
                                    onChange={(e) => handleChange(e)}
                                    max={moment().format("YYYY-MM-DD")}
                                    onKeyDown={(e) => disableKey(e)}
                                    pattern='(0[1-9]|1[1,2])(\/|-)(0[1-9]|[12][0-9]|3[01])(\/|-)(19|20)\d{2}' 
                                required />
                                    <div className="invalid-feedback">INVALID CITATION DATE</div></>
                                )}
                                    
                            </div>
                            <div className="col-md-3">
                                <label className="form-label">
                                    <b><span className="text-danger">*</span>Conviction Date</b>
                                </label>
                                <input type="date" className="form-control" 
                                    placeholder="MM/DD/YYYY"
                                    name="convictionDate"
                                    onChange={(e) => handleChange(e)}
                                    max={moment().format("YYYY-MM-DD")}
                                    onKeyDown={(e) => disableKey(e)}
                                    pattern='(0[1-9]|1[1,2])(\/|-)(0[1-9]|[12][0-9]|3[01])(\/|-)(19|20)\d{2}' 
                                required />
                                <div className="invalid-feedback">INVALID CONVICTION DATE</div>
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label">
                                        <b><span className="text-danger">*</span>Court Type:</b>
                                    </label>
                                <select
                                    className="form-control form-select"
                                    required
                                    value={courtType}
                                    onChange={(e) => setCourtType(e.target.value)}
                                >
                                    <option value="" disabled>
                                            -- Court Type --
                                    </option>
                                        {courtTypesByState[userCourtType].map((opt) => (
                                            <option key={opt.code} value={opt.code}>
                                                {opt.label}
                                    </option>
                                    ))}
                                </select>
                                <div className="invalid-feedback"><span className="text-danger">*</span>Please select a Court Type</div>
                                </div>
                                <div className="col-md-3">
                                    <div>
                                    {roles && ( roles.includes("fcwdHelpDesk") ) &&   
                                        <th><p>
                                            <label className="form-label"><span className="text-danger">*</span>State:</label>
                                                <StateSel handleChange={handleChange}   
                                                    value={formData?.userState}
                                                    formData={formData} />
                                        <div className="invalid-feedback">Please Select a State</div>
                                        </p></th>
                                    }
                                </div>
                                </div>
                            </div>
    
                            <div className="row">
                                <div className="col-md-3">
                                    <label className="form-label">
                                        <b><span className="text-danger">*</span>ACD Code</b>
                                    </label>
                                    <select
                                        className="form-control form-select"
                                        onClick={(e)=>checkACD(e)}
                                        value={acdCode}
                                        onChange={handleAcdChange}
                                        required
                                    >
                                        <option value="" disabled>
                                            -- ACD Code --
                                        </option>
                                    {acdCodes.map((opt) => (
                                        !opt.code.includes('W') && (
                                        <option key={opt.code} value={opt.code} title={opt.label}>
                                            {opt.code} - {opt.simple}
                                        </option>)
                                    ))}
                                    </select>
                                    <div className="invalid-feedback">Please select an ACD Code</div>
    
                                    {selectedAcd && (
                                        <div className="mt-1">
                                            <span
                                                className="text-primary text-decoration-underline"
                                                role="button"
                                                data-bs-toggle="modal"
                                                data-bs-target="#acdInfoModal"
                                            >
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="16"
                                                    height="16"
                                                    fill="currentColor"
                                                    className="bi bi-info-circle"
                                                    viewBox="0 0 16 16"
                                                >
                                                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                                                    <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0" />
                                                </svg>
                                            </span>
                                        </div>
                                    )}
                                </div>
    
                            <div className="col-md-5">
                                {selectedAcd ? (
                                    selectedAcd.required == null ? (
                                        <div>
                                        <label className="form-label"><b>ACD Details</b></label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="acdDetails"
                                            value={""}
                                            readOnly
                                        /></div>
                                    ) : selectedAcd.required ? (
                                        <div>
                                            <label className="form-label">
                                                <span className="text-danger">*</span><b>ACD Details</b>
                                            </label>
                                            <input
                                                ref={acdDetailsRef}
                                                pattern="[A-Za-z0-9]*"
                                                type="text"
                                                className="form-control"
                                                name="acdDetail"
                                                maxLength={maxVal}
                                                value={acdDetail}
                                                onChange={(e) => setAcdDetail(e.target.value)}
                                                required
                                            />
                                            <div className="invalid-feedback">
                                                INVALID CONV OFF DETAIL FOR GIVEN ACD CONV CODE FOR ACD CONV CODE: {selectedAcd.code}
                                            </div>
                                        </div>
                                    ) : (
                                        <div>
                                            <label className="form-label"><b>ACD Details</b></label>
                                        <input
                                            ref={acdDetailsRef}
                                            pattern="[A-Za-z0-9]*"
                                            type="text"
                                            className="form-control"
                                            name="acdDetail"
                                            maxLength={maxVal}
                                            value={acdDetail}
                                            onChange={(e) => setAcdDetail(e.target.value)}
                                        />
                                        </div>
                                    )
                                ) : (
                                    <div>
                                        <label className="form-label"><b>ACD Details</b></label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="acdDetails"
                                        readOnly
                                    />
                                    </div>
                                )}
                            </div>
                                <div className="col">
                                    <label className="form-label">
                                        <b><span className="text-danger">*</span>CMV</b>
                                    </label>
                                    <select
                                        className="form-control form-select"
                                        value={cmvCode}
                                        onChange={(e) => setCmvCode(e.target.value)}
                                        required
                                    >{hazMat === "1" ? (
                                        <option value="2">1 – Yes</option>
                                         ): (
                                    
                                        <><option value="" disabled>
                                                    -- CMV --
                                                </option>
                                                <option value="1">1 – Yes</option>
                                                <option value="2">2 – No</option>
                                                <option value="9">9 – Unknown</option></>
                                    )}
                                    </select>
                                    { hazMat === "h1" && (
                                        <div className="form-text">
                                        If the Hazmat is Yes, CMV must be Yes.
                                    </div>)}
                                    
                                    <div className="invalid-feedback">Please select CMV</div>
                                </div>
    
                                <div className="col">
                                    <label className="form-label">
                                        <b><span className="text-danger">*</span>Hazmat</b>
                                    </label>
                                    <select
                                        className="form-control form-select"
                                        value={hazMat}
                                        onChange={(e) => setHazMat(e.target.value)}
                                        required
                                    >
                                        <option value="" disabled>
                                            -- Hazmat --
                                        </option>
                                        <option value="1">1 – Yes</option>
                                        <option value="2">2 – No</option>
                                        <option value="9">9 – Unknown</option>
                                    </select>
                                    <div className="invalid-feedback">Please select Hazmat</div>
                                </div>
                            </div>
    
                            <div className="row">
                                <div className="col">
                                    <label className="form-label">
                                        <b><span className="text-danger">*</span>Conviction Offense Locator</b>
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="convOff"
                                        value={formData.convOff}
                                        onChange={(e) => handleChange(e)}
                                        maxLength={18}
                                        required
                                    />
                                    <div className="invalid-feedback">
                                        Please enter Conviction Offense Locator
                                    </div>
                                </div>
                                <div className="col">
                                    <label className="form-label">
                                        <b><span className="text-danger">*</span>State Native Code</b>
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="stateNative"
                                        value={formData.stateNative}
                                        onChange={(e) => handleChange(e)}
                                        maxLength={8}
                                        required
                                    />
                                    <div className="invalid-feedback">
                                        Please enter State Native Code
                                    </div>
                                </div>
                                <div className="col">
                                    <label className="form-label">
                                        <b><span className="text-danger">*</span>Comments</b>
                                    </label>
                                    <textarea
                                        type="text"
                                        className="form-control"
                                        name="comments"
                                        value={formData.comments}
                                        onChange={(e) => handleChange(e)}
                                        maxLength={500}
                                        required
                                    />
                                    <div className="invalid-feedback">Please enter Comments</div>
                                </div>
                            </div>
    
                            <button type="submit" className="btn btn-primary mt-3">
                                Add Conviction
                            </button>
                            <button type="button" onClick={(e) => handleCancel(e)} 
                                className="btn btn-secondary mt-3 ms-2">
                                Back to Details for DL:{license}
                            </button>
                        </form>
                    </div>
                </div>
    
                {selectedAcd && (
                    <div
                        className="modal fade"
                        id="acdInfoModal"
                        tabIndex="-1"
                        aria-labelledby="acdInfoModalLabel"
                        aria-hidden="true"
                    >
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title" id="acdInfoModalLabel">
                                        ACD Code Information
                                    </h5>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        data-bs-dismiss="modal"
                                        aria-label="Close"
                                    ></button>
                                </div>
                                <div className="modal-body">
                                    <p>
                                        <strong>ACD Code:</strong> {selectedAcd.code}
                                    </p>
                                    <p>
                                        <strong>Description:</strong> {selectedAcd.label}
                                    </p>
                                    {selectedAcd.validation && (
                                        <p>
                                            <strong>Validation:</strong> {selectedAcd.validation}
                                        </p>
                                    )}
                                    {selectedAcd.moreInfo && (
                                        <p>
                                            <strong>More Info:</strong> {selectedAcd.moreInfo}
                                        </p>
                                    )}
                                </div>
                                <div className="modal-footer">
                                    <button
                                        type="button"
                                        className="btn btn-secondary"
                                        data-bs-dismiss="modal"
                                    >
                                        Close
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </>
        );
    }